import React from 'react';
import { MessageSquare, GraduationCap, FileText, CheckCircle, Award } from 'lucide-react';
import { processSteps } from '../mock';
import { Link } from 'react-router-dom';

const iconMap = {
  MessageSquare,
  GraduationCap,
  FileText,
  CheckCircle,
  Award
};

export const Process = () => {
  return (
    <section id="process" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Getting a reverse mortgage is straightforward. I'll guide you through every step of our proven 5-step process 
            to help you access your home equity with confidence and clarity.
          </p>
        </div>

        {/* Process Steps */}
        <div className="relative">
          {/* Connection Line - Desktop Only */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-0.5 bg-blue-200" style={{ left: '10%', right: '10%' }}></div>

          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8 relative">
            {processSteps.map((step, index) => {
              const IconComponent = iconMap[step.icon];
              const content = (
                <div key={`content-${step.id}`} className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-blue-200 h-full">
                  {/* Step Number */}
                  <div className="absolute -top-4 left-6 w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-lg shadow-lg">
                    {step.id}
                  </div>

                  {/* Icon */}
                  <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4 mt-4">
                    <IconComponent className="w-7 h-7 text-blue-600" />
                  </div>

                  {/* Content */}
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {step.description}
                  </p>
                </div>
              );

              return (
                <div key={step.id} className="relative">
                  {/* Step Card - with link on first step */}
                  {step.link ? (
                    <Link to={step.link} className="block">
                      {content}
                    </Link>
                  ) : (
                    content
                  )}

                  {/* Mobile Arrow */}
                  {index < processSteps.length - 1 && (
                    <div className="lg:hidden flex justify-center my-4">
                      <div className="w-0.5 h-8 bg-blue-200"></div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Timeline Info */}
        <div className="mt-16 text-center bg-white rounded-xl p-8 shadow-md">
          <p className="text-gray-700 text-lg mb-2">
            <span className="font-semibold text-blue-600">Typical timeline:</span> 30-45 days from application to closing
          </p>
          <p className="text-gray-600">
            Every situation is unique. I'll provide a personalized timeline during your consultation.
          </p>
        </div>
      </div>
    </section>
  );
};
